'use client';

import React from 'react';
import { Shield } from 'lucide-react';
import LegalDocumentBody from '@/components/LegalDocumentBody';
import { useLanguage } from '@/context/LanguageContext';

export default function SecurityContent() {
  const { t } = useLanguage();
  const common = t?.legalPages?.common;

  return (
    <LegalDocumentBody
      pageId="security"
      badge={common?.trustBadge ?? 'Trust & Safety'}
      icon={<Shield size={13} className="text-primary" />}
      showReportBox
      footerLinks={[
        { href: '/privacy-policy', labelKey: 'privacyLink' },
        { href: '/terms-of-service', labelKey: 'termsLink' },
        { href: '/refund-policy', labelKey: 'refundLink' },
      ]}
    />
  );
}
